var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('BarChart',{attrs:{"series":_vm.chartSeries,"categories":_vm.chartCategories,"type":"bar","colors":_vm.chartColors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }